import { CarouselContext } from "pure-react-carousel"
import React, { useContext, useEffect, useState } from "react"

import styles from "./ImageCarouselCurrentSlide.module.scss"

const ImageCarouselCurrentSlide = ({ children }) => {
  const carouselContext = useContext(CarouselContext)
  const [currentSlide, setCurrentSlide] = useState(
    carouselContext.state.currentSlide
  )

  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide)
    }
    carouselContext.subscribe(onChange)
    return () => carouselContext.unsubscribe(onChange)
  }, [carouselContext])

  return (
    <div className={styles.item}>
      {currentSlide + 1} / {carouselContext.state.totalSlides}
    </div>
  )
}

export default ImageCarouselCurrentSlide
